import React from "react";
// import "@mantine/core/styles.css";
// import "@mantine/core/styles.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "./Fonts/Ray.ttf";
import "react-treeview/react-treeview.css";
import { MantineProvider } from "@mantine/core";

// import "antd/dist/antd.css"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MantineProvider
      theme={{ dir: "rtl", fontFamily: "vazir-light, sans-serif" }}
    >
      <App />
    </MantineProvider>
  </React.StrictMode>
);
